import { render, staticRenderFns } from "./CardAmount.vue?vue&type=template&id=2486c058"
import script from "./CardAmount.vue?vue&type=script&lang=js"
export * from "./CardAmount.vue?vue&type=script&lang=js"
import style0 from "./CardAmount.vue?vue&type=style&index=0&id=2486c058&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2486c058')) {
      api.createRecord('2486c058', component.options)
    } else {
      api.reload('2486c058', component.options)
    }
    module.hot.accept("./CardAmount.vue?vue&type=template&id=2486c058", function () {
      api.rerender('2486c058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/identifiers/components/CardAmount.vue"
export default component.exports